import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import c from 'classnames';

import Loader from '../../components/Loader';
import { updateLayout } from '../../sagas/layout/actions';

import './_page.scss';

const Page = ({ children, hideNavbar = false, hideMenu = false, loading = false, className = '', whiteBackground = false }) => {
  const dispatch = useDispatch();
  const layout = useSelector(s => s.layout);
  const pageClass = c('pageSection', className);

  useEffect(() => {
    const newLayout = {
      navbar: !hideNavbar, menu: !hideMenu, whiteBackground: !whiteBackground
    };

    if (!isEqual(layout, newLayout)) {
      dispatch(updateLayout(newLayout));
    }
  }, []); // eslint-disable-line

  return (
    <section className={pageClass}>
      {loading && <Loader />}
      {children}
    </section>
  );
};

Page.propTypes = {
  children: PropTypes.node.isRequired,
  hideNavbar: PropTypes.bool,
  hideMenu: PropTypes.bool,
  loading: PropTypes.bool,
  whiteBackground: PropTypes.bool,
  className: PropTypes.string
};

export default Page;
